
<pbir-visual-style-editor [busy]="busy()" [visual]="visual()">
  <ng-container appearanceAfter>
    <ng-content select="[appearanceAfter]"></ng-content>

    <label>Row Height:</label>
    <mat-select class="trg-outline user-select-none" panelClass="trg-outline-dropdown"
                [disabled]="busy()"
                [value]="tableLayout()"
                (valueChange)="setValue(tableLayout, $event)">
      @for (x of TableLayoutOptions; track x.id) {
      <mat-option [value]="x">{{x.title}}</mat-option>
      }
    </mat-select>

    <!-- IN-7392
    @if (isPivot) {
    <label>Group Display:</label>
    <mat-select class="trg-outline user-select-none" panelClass="trg-outline-dropdown"
                [disabled]="busy()"
                [value]="pivotColumnDisplay()"
                (valueChange)="setValue(pivotColumnDisplay, $event)">
      @for (x of PivotColumnDisplayOptions; track x.id) {
      <mat-option [value]="x">{{x.title}}</mat-option>
      }
    </mat-select>
    }
    -->
  </ng-container>
</pbir-visual-style-editor>